import numbro from 'numbro';

numbro.registerLanguage({
    languageTag: "hr-HR",
    delimiters: {
        thousands: " ",
        decimal: ","
    },
    abbreviations: {
        thousand: " 000",
        million: " 000 000",
        billion: " mlrd.",
        trillion: " bil."
    },
    ordinal: function() {
        return "."
    },
    currency: {
        symbol: "Kn",
        position: "postfix",
        code: "HRK"
    },
    currencyFormat: {
        thousandSeparated: true,
        totalLength: 4,
        spaceSeparated: true,
        average: true
    },
    formats: {
        fourDigits: {
            totalLength: 4,
            spaceSeparated: true,
            average: true
        },
        fullWithTwoDecimals: {
            output: "currency",
            mantissa: 2,
            spaceSeparated: true,
            thousandSeparated: true
        },
        fullWithTwoDecimalsNoCurrency: {
            mantissa: 2,
            thousandSeparated: true
        },
        fullWithNoDecimals: {
            output: "currency",
            spaceSeparated: true,
            thousandSeparated: true,
            mantissa: 0
        }
    }
});

numbro.setDefaults({
    thousandSeparated: true,
    mantissa: 2
});

// numbro.setLanguage(i18n.language);